import { render } from "./data_pegawai.vue?vue&type=template&id=6de50792"
import script from "./data_pegawai.vue?vue&type=script&lang=js"
export * from "./data_pegawai.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__